import React, { useState } from "react";
import { Icons } from "../components/Icons";
import { FAQS } from "../data/catalog";

const FAQsPage = ({ go }) => {
  const [open, setOpen] = useState(null);

  return (
    <>
      <div className="page-hero">
        <div className="wrap page-hero-inner">
          <div className="breadcrumb">
            <span>Home</span>
            <Icons.ChevronRight size={12} />
            <em>FAQs</em>
          </div>
          <span className="badge badge-blue">Support Center</span>
          <h1>Frequently Asked Questions</h1>
          <p>
            Everything you need to know about wholesale ordering, payment, and
            shipping with NewCover Ltd.
          </p>
        </div>
      </div>
      <section className="section">
        <div className="wrap">
          <div className="section-header center">
            <span className="badge badge-blue">Got Questions?</span>
            <h2 className="sh-title">We Have the Answers</h2>
            <div className="sh-line center" />
          </div>
          <div className="faq-list">
            {FAQS.map((faq, i) => (
              <div key={i} className={`faq-item${open === i ? " open" : ""}`}>
                <button
                  className="faq-btn"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="faq-q">{faq.q}</span>
                  <span className="faq-chevron">
                    <Icons.ChevronDown size={13} />
                  </span>
                </button>
                <div className={`faq-body${open === i ? " open" : ""}`}>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 60 }}>
            <div
              style={{
                background: "var(--gray-50)",
                border: "1.5px solid var(--gray-200)",
                borderRadius: "var(--radius-xl)",
                padding: 44,
                maxWidth: 480,
                margin: "0 auto",
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  background: "var(--blue-50)",
                  borderRadius: "var(--radius)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                }}
              >
                <Icons.Headphones size={22} color="#2563eb" />
              </div>
              <h3 style={{ marginBottom: 8 }}>Still have questions?</h3>
              <p style={{ marginBottom: 22 }}>
                Our B2B support team responds within 2 hours on business days.
              </p>
              <a href="mailto:info@newcoverltd.com">
                <button className="btn btn-primary">
                  <Icons.Mail size={15} color="#fff" /> Email Our Team
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQsPage;
